/**
 * Smooth fade-up animation for chat messages.
 * Instead of FLIP morphing, creates a natural chat-like appearance.
 */
export function animateFlip(
    source: HTMLElement,
    dest: HTMLElement,
    duration = 320
): Promise<void> {
    return new Promise((resolve) => {
        try {
            // reference source param to avoid unused variable under strict TS
            void source;
            // Simply fade in the destination with a subtle slide-up
            dest.style.opacity = "0";
            dest.style.transform = "translateY(12px)";
            dest.style.transition = `opacity ${duration}ms cubic-bezier(0.2, 0.8, 0.2, 1), transform ${duration}ms cubic-bezier(0.2, 0.8, 0.2, 1)`;

            // Force reflow
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            dest.getBoundingClientRect();

            requestAnimationFrame(() => {
                dest.style.opacity = "1";
                dest.style.transform = "translateY(0)";
            });

            const cleanup = () => {
                // Clean up inline styles after animation
                dest.style.opacity = "";
                dest.style.transform = "";
                dest.style.transition = "";
                resolve();
            };

            // Fallback if transitionend doesn't fire
            const timeout = window.setTimeout(() => cleanup(), duration + 80);

            dest.addEventListener(
                "transitionend",
                () => {
                    clearTimeout(timeout);
                    cleanup();
                },
                { once: true }
            );
        } catch (err) {
            // On error, just resolve and don't block the flow
            // eslint-disable-next-line no-console
            console.debug("message animation failed", err);
            resolve();
        }
    });
}
